import { render, staticRenderFns } from "./ZonesTableContainer.vue?vue&type=template&id=0bdb5913&"
import script from "./ZonesTableContainer.vue?vue&type=script&lang=ts&"
export * from "./ZonesTableContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports